import { Id } from "PFCore/types";

const cache: Record<string, string> = {};
const SECOND_MS = 1000;
const ONE_HOUR_MS = 60 * 60 * SECOND_MS;

const getExpire = (url: string) => {
  const params = new URLSearchParams(url.replace(/[^?]*\?/, ""));
  return Number(params.get("Expires") || 0);
};

const isExpired = (url: string) => getExpire(url) * SECOND_MS < +new Date() + ONE_HOUR_MS;

export const fromCache = (id: Id, mode: "full" | "thumb", url: string = "") => {
  const key = `${mode}:${id}:${url.replace(/\?.*/, "")}`;
  const prevUrl = cache[key];

  if (!prevUrl || isExpired(prevUrl)) {
    cache[key] = url;
    return url;
  } else {
    return prevUrl;
  }
};
